// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.floating-alert {
  position: fixed;
  top: 1.2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: 19.2857142857rem;
}

.alert {
  border-radius: 1.7142857143rem;
  min-height: 2.4285714286rem;
  font-weight: bold;
  color: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
}

.alert-danger {
  background: #ac0000;
  border: 1px solid rgba(172, 0, 0, 0.5);
}

.alert-success {
  background: #b1c57b;
  border: 1px solid rgba(177, 197, 123, 0.5);
}

.alert-info {
  background: #eed395;
  border: 1px solid rgba(238, 211, 149, 0.5);
  color: #6b645e;
}

.close-icon {
  width: 1.1428571429rem;
  height: 1.1428571429rem;
  float: right;
}

.sticky {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  50% {
    box-shadow: 0 0 35px rgba(0, 0, 0, 0.4);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/toast-message/toast-message.component.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;ECsCA,uBAAA;ADtCF;;AAIA;ECkCE,8BAAA;EAAA,2BAAA;ED/BA,iBAAA;EACA,cAAA;EACA,wCAAA;AADF;;AAIA;EACE,mBAAA;EACA,sCAAA;AADF;;AAIA;EACE,mBAAA;EACA,0CAAA;AADF;;AAIA;EACE,mBAAA;EACA,0CAAA;EACA,cAAA;AADF;;AAIA;ECUE,sBAAA;EAAA,uBAAA;EDPA,YAAA;AADF;;AAIA;EACE,4BAAA;AADF;;AAIA;EACE;IACE,uCAAA;EADF;AACF","sourcesContent":["@import 'variables';\n\ndiv.floating-alert {\n  position: fixed;\n  top: 1.2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  @include pixelToRem(width, 270px);\n}\n\n.alert {\n  @include pixelToRem(border-radius, 24px);\n  @include pixelToRem(min-height, 34px);\n  font-weight: bold;\n  color: #ffffff;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);\n}\n\n.alert-danger {\n  background: #ac0000;\n  border: 1px solid rgba(172, 0, 0, 0.5);\n}\n\n.alert-success {\n  background: #b1c57b;\n  border: 1px solid rgba(177, 197, 123, 0.5);\n}\n\n.alert-info {\n  background: #eed395;\n  border: 1px solid rgba(238, 211, 149, 0.5);\n  color: #6b645e;\n}\n\n.close-icon {\n  @include pixelToRem(width, 16px);\n  @include pixelToRem(height, 16px);\n  float: right;\n}\n\n.sticky {\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  50% {\n    box-shadow: 0 0 35px rgba(0, 0, 0, 0.4);\n  }\n}\n","$primary: #ffcd00;\n$secondary: #00a3ae;\n$dark: #707070;\n$base-font-size: 14px;\n\n$header-top-height: 48px;\n$header-bottom-height: 21px;\n$header-border-radius: 24px;\n$header-total-height: $header-top-height + $header-bottom-height;\n$tray-radius: 16px;\n\n$input-border-radius: 24px;\n$input-side-padding: 25px;\n$header-top-color: #ffffff;\n$header-bottom-color: #ededed;\n$text-color: #6b645e;\n$login-bg-color: #a5a498;\n$card-bg-color: #f5f5f5;\n$info-text-color: #a5a498;\n$support-card-bg-color: #7ed0d6;\n$support-card-inactive-color: #bcd8df;\n$support-card-text-color: #f5f5f5;\n$category-border-radius: 16px;\n$product-border-radius: 8px;\n$textarea-border-color: #bcd8df;\n$button-border-radius: 48px;\n$support-button-size: 84px;\n$support-button-margin: 24px;\n$gradient-height: 10%;\n$body-bottom-margin: 15%;\n$input-border-color: #edbf00;\n$image-text-bg-opacity: 0.7;\n$primary-btn-border: rgba(255, 205, 0, 1);\n$fade-bg-color: #ffffffb3;\n\n@mixin set-flex($number) {\n  flex: $number;\n}\n\n@function calculateRem($size) {\n  $remSize: calc($size / $base-font-size);\n  @return #{$remSize}rem;\n}\n\n@mixin pixelToRem($attribute, $size) {\n  #{$attribute}: calculateRem($size);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
